<!-- title -->
<app-modal-title
  [title]="formPageConfig.title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form">
    <div
      class="tw-mt-[10px] tw-rounded-[10px] tw-items-center bg-light rounded tw-p-5 tw-mb-5"
    >
      <span copyToClipboard>{{ "messages.receiversExcel" | translate }}</span>
    </div>

    <div class="tw-w-full">
      <div class="tw-flex-center tw-flex-col">
        <!-- title -->
        <form-field
          [(value)]="title"
          class="tw-w-full"
          label="common.title"
          [control]="form?.get('title')"
        >
        </form-field>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [btnType]="'submit'"
      [isEdit]="false"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
